import { useMemo } from 'react';
import { useApplicationContext } from 'shared/containers/ApplicationContext';

export function useAdBannerMicrofrontendEnabled() {
  const { config } = useApplicationContext();

  return useMemo(() => config.get<boolean>('MarTech.AdBannerMicrofrontend.Enabled'), [config]);
}
